import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/manga';

export default function HotList() {
  const hotManga = [...mangaList].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <section className="max-w-[1440px] mx-auto px-4 md:px-6 py-12" aria-labelledby="hot-title">
      <div className="flex items-center justify-between mb-8">
        <h2 id="hot-title" className="font-heading text-2xl font-bold text-foreground-900">
          热门排行
        </h2>
        <Link
          to="/category/kr"
          className="text-sm text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1 cursor-pointer"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {hotManga.map((manga, index) => (
          <Link
            key={manga.id}
            to={`/article/${manga.id}`}
            className="group cursor-pointer"
          >
            <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
              <img
                src={manga.cover}
                alt={manga.title}
                title={`${manga.title} - 星星动漫网`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 left-2 w-7 h-7 rounded-md bg-primary-500 text-white flex items-center justify-center text-xs font-bold">
                {index + 1}
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                <div className="flex items-center gap-2 text-white/90 text-xs">
                  <i className="ri-eye-line"></i>
                  <span>{manga.views >= 10000 ? `${(manga.views / 10000).toFixed(0)}万` : manga.views}</span>
                  <span className="ml-auto flex items-center gap-1">
                    <i className="ri-star-fill text-yellow-400"></i>
                    {manga.rating}
                  </span>
                </div>
              </div>
            </div>
            <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
              {manga.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-1">{manga.author}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}